module.exports = __webpack_public_path__ + "img/Gradient_viridis.59402ec6.png";